var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRetake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.91437 2.38631C5.53174 2.52846 5.16709 2.70832 4.82514 2.92191C4.0042 3.43472 3.31415 4.14196 2.82055 4.98852C2.12134 6.18769 1.85956 7.5922 2.07981 8.96275C2.30006 10.3333 2.98871 11.5851 4.02843 12.5048M10.4454 13.4915C11.044 13.2248 11.5992 12.86 12.0865 12.4075C13.1037 11.4629 13.762 10.1949 13.949 8.81939C14.1361 7.44392 13.8405 6.04614 13.1125 4.86421C12.4767 3.83191 11.5455 3.02004 10.4454 2.52999",
    stroke: "#ABB2B4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 13.2612L5 13.2612L5 10.7612",
    stroke: "#ABB2B4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 2.01123L10.25 2.01123L10.25 4.51123",
    stroke: "#ABB2B4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetake);
export default __webpack_public_path__ + "static/media/retake.d493f0097522537a338f0a2718f0d84a.svg";
export { ForwardRef as ReactComponent };